import { Chip } from "@mui/material";
import UtilService from "../../services/UtilService";

export function getInviterColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "inviterUser",
            headerName: "Inviter",
            flex: 2,
            editable: false,
            renderCell: (params) => {
                const user = params.value;
                if (!user) return "-";
                const name = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
                return name || user.email || user.id || "-";
            },
        },
        {
            field: "inviterUserEmail",
            headerName: "Email",
            flex: 2,
            editable: false,
            valueGetter: (_value, row) => {
                return row?.inviterUser?.email || "";
            },
            renderCell: (params) => {
                const email = params.row?.inviterUser?.email;
                return email || "-";
            },
        },
        {
            field: "acceptedCount",
            headerName: "Accepted",
            flex: 1,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "pendingCount",
            headerName: "Pending",
            flex: 1,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "rewardGranted",
            headerName: "Reward Granted",
            flex: 1,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <Chip
                        label={params.value ? "Yes" : "No"}
                        color={params.value ? "success" : "default"}
                        size="small"
                    />
                );
            },
        },
        {
            field: "createdAt",
            headerName: "Created",
            flex: 1.5,
            editable: false,
            renderCell: (params) => {
                if (!params.value) return "";
                return UtilService.formatDate(params.value);
            },
        },
    ];
}

